import Script from 'next/script';
import config from 'lib/config';

import NewRelic from 'components/tags/NewRelic';
import Comscore from 'components/tags/Comscore';
import GoogleTagManager from 'components/tags/GoogleTagManager';
import SnowPlow from 'components/tags/SnowPlow';
import Facebook from 'components/tags/Facebook';
import OpenWrap from 'components/tags/OpenWrap';

export default function AppScripts(): JSX.Element {
  return (
    <>
      <OpenWrap />
      <Script
        src="https://securepubads.g.doubleclick.net/tag/js/gpt.js"
        strategy="afterInteractive"
        key="gpt"
      />
      <Script src="//static.criteo.net/js/ld/ld.js" strategy="afterInteractive" key="criteo" />
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=AW-${config.googleAdwordsConversionIdNew}`}
        strategy="afterInteractive"
        key="gtag"
      />
      <Script
        src={`https://maps.googleapis.com/maps/api/js?key=${config.googleMapsApiKey}&libraries=places`}
        strategy="lazyOnload"
        key="google-maps"
      />
      <Script src="https://accounts.google.com/gsi/client" strategy="afterInteractive" />
      <NewRelic />
      <Comscore />
      <GoogleTagManager />
      <SnowPlow />
      <Facebook />
    </>
  );
}
